import { Component } from '@angular/core';

@Component({
  selector: 'tl-spinner',
  standalone: true,
  imports: [],
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {

}
